import React, { useState } from 'react';
import { useDocumentTitle } from '../../hooks/use-document-title';
import { Heading } from '../onboarding.styled';
import { Body } from './public-stay-page.styled';
import { GuestCheckinPage } from '../../pages/stays/guest/guest-checkin-page';
import { StayGuestPage } from './stay-guest-page';
import { readReturn, StayShell, useNoReferrer } from './stay-steps';
import { t } from './stay-strings';

/**
 * BACK FROM THE ID PARTNER — /s/return (Lobbero Stays, plan S3).
 *
 * The partner's return URL carries NO token (it would sit in their logs and in
 * this browser's history). The page that sent the guest away wrote
 * sessionStorage['lobbero.stay.return'] = {kind, token} just before the hop;
 * this page reads it and renders that page with the token as a PROP — never
 * reading a token from the URL, never writing one into the address bar. The
 * page then asks the server every 3 s for up to a minute while the answer is
 * on its way. Plan S6: the lead's page is the full check-in
 * (GuestCheckinPage), opened on its "ID check" step.
 *
 * No storage (another browser, private mode, cleared data): one sentence,
 * asking the guest to open their link again.
 */

const NoStorage: React.FC = () => {
  useNoReferrer();
  useDocumentTitle(t('en', 'documentTitle'));

  return (
    <StayShell>
      <Heading>{t('en', 'returnTitle')}</Heading>
      <Body>{t('en', 'returnNoStorage')}</Body>
    </StayShell>
  );
};

export const StayReturnPage: React.FC = () => {
  // Read once: a later write by another tab must not swap the stay under this one.
  const [back] = useState(() => readReturn());
  if (!back) return <NoStorage />;

  return back.kind === 'sg' ? (
    <StayGuestPage token={back.token} returning />
  ) : (
    <GuestCheckinPage token={back.token} returning />
  );
};
